import { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import beveatApiResourceOwner from "../../../api/resource_owner_beveat_api.js";
import CreateCertificateDetailsModal from "./create_certificate_details_modal.jsx";
import { pricingPlanCurrentTabContext } from "../context/pricing_plan_context.jsx";
import { getUser } from "../../../services/local_service.js";
import { urls, commonConfigs } from "../../../../config.js";
import { DEVELOPER_PROJ_STATUS } from "../../../constants/developer_proj_status.jsx";
import { InvoicePlanSyscodeString } from "../../../constants/invoice_plan_syscode.jsx";

export default function PaymentsApiCatalogueCard({
  industry,
  plan,
  price,
  planId,
  benefits,
  onButtonClick,
  handleComingSoonClick,
  buttonLabel,
}) {
  const { currentTab } = useContext(pricingPlanCurrentTabContext);
  const [certificates, setCertificates] = useState([]);
  const [project, setProject] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [load, setLoad] = useState(true);

  const ssoId = getUser()?.sso_id;
  const accountId = getUser()?.account_id;
  const navigate = useNavigate();

  const getDeveloperCertificatesUrl =
    urls.resourceOwnerUrl +
    commonConfigs.apiUrls.getAllDeveloperCertificates(accountId);

  useEffect(() => {
    async function init() {
      try {
        await getDeveloperCertificates();
        await getDeveloperProjectByPlan(planId);
        setLoad(false);
      } catch (err) {
        console.error("Initialization error:", err);
      }
    }
    init();
  }, []);

  async function getDeveloperCertificates() {
    const res = await beveatApiResourceOwner.get(getDeveloperCertificatesUrl, {
      headers: commonConfigs.resourceOwnerApiHeader,
    });
    setCertificates(res.data.result.data);
  }

  async function getDeveloperProjectByPlan(planId) {
    const url =
      urls.resourceOwnerUrl +
      commonConfigs.apiUrls.getDeveloperProjectByPlan(ssoId, planId);
    const res = await beveatApiResourceOwner.get(url, {
      headers: commonConfigs.resourceOwnerApiHeader,
    });
    const projectData = res.data.result.data;
    if (projectData) {
      setProject(projectData);
      if (projectData.developer_proj_status === DEVELOPER_PROJ_STATUS.Active) {
        // setShowDetails(true);
        await getDeveloperCourse(planId, projectData.developer_proj_id);
      }
    }
  }

  async function getDeveloperCourse(planId, projId) {
    const url =
      urls.resourceOwnerUrl +
      commonConfigs.apiUrls.getDeveloperCourses(accountId, planId, 0);

    const res = await beveatApiResourceOwner.get(url, {
      headers: commonConfigs.resourceOwnerApiHeader,
    });

    if (Object.keys(res.data.result.data).length !== 0) {
      setShowDetails(true);
    } else {
      await updateDeveloperProj(projId);
      await updateDoublewriteDevProj(projId);
    }
  }

  async function updateDeveloperProj(projId) {
    const url =
      urls.resourceOwnerUrl +
      commonConfigs.apiUrls.UpdateDeveloperProject(projId, currentTab.invoicePlanSyscode);

    await beveatApiResourceOwner.put(
      url,
      { developer_proj_status: DEVELOPER_PROJ_STATUS.Expired },
      { headers: commonConfigs.resourceOwnerApiHeader }
    );
  }

  async function updateDoublewriteDevProj(projId) {
    const { url, headers } = doublewriteConfig(process.env.REACT_APP_ENV);
    const doublewriteUrl =
      url + commonConfigs.apiUrls.UpdateDeveloperProject(projId, currentTab.invoicePlanSyscode);

    await beveatApiResourceOwner.put(
      doublewriteUrl,
      { developer_proj_status: DEVELOPER_PROJ_STATUS.Expired },
      { headers }
    );
  }

  const onGetCertificateClick = () => {
    const certificate = certificates.find(
      (cert) =>
        cert.org_invoice_plan_id === planId &&
        cert.developer_proj_id === project?.developer_proj_id
    );

    if (certificate) {
      let tabValue = 0; // default to NETS QR

      if (plan.invoice_plan.toLowerCase().includes("click")) {
        tabValue = 1; // NETS Click
      } else if (plan.invoice_plan.toLowerCase().includes("enets")) {
        tabValue = 2; // eNETS
      }

      navigate("/certification", {
        state: {
          planName: plan.invoice_plan,
          certificationPlanId: planId,
          environment: InvoicePlanSyscodeString[currentTab.invoicePlanSyscode],
          devProjId: project.developer_proj_id,
          tabValue: tabValue, // pass the tabValue here!
        },
      });
    } else {
      setOpen(true);
    }
  };

  if (!load) {
    return (
      <div className="bg-white shadow-lg rounded-lg w-full mx-auto h-[26rem] flex flex-col justify-between" style={{ maxWidth: "20rem" }}>
        <div className="p-6 text-black">
          <div className="bg-blue-400 text-white font-bold text-lg py-1 rounded-full mb-2">{industry}</div>
          <p className="text-3xl font-bold text-gray-800 mb-1">${price}</p>
          <ul className="text-left" style={{ listStyleType: "circle", paddingLeft: "20px", marginTop: "24px" }}>
            {benefits.map((benefit, index) =>
              typeof benefit === "string" ? (
                <li key={index} className="mb-2">{benefit}</li>
              ) : (
                <li key={index} className="mb-2">
                  {benefit.title}
                  <ul style={{ paddingLeft: "20px", listStyleType: "circle" }}>
                    {benefit.children.map((child, i) => (
                      <li key={i} className="mb-2">{child}</li>
                    ))}
                  </ul>
                </li>
              )
            )}
          </ul>
        </div>
        <div>
          {showDetails ? (
            <div className="flex border-t border-white">
              <Link
                to={`/projects/details`}
                className="flex-1 bg-blue-400 text-white py-3 font-semibold hover:bg-blue-600 text-center"
                state={{
                  developerSsoId: ssoId,
                  developerProjId: project.developer_proj_id,
                  invoicePlanSyscode: currentTab.invoicePlanSyscode
                }}
              >
                View Project Details
              </Link>
              <div className="w-[1px] bg-white"></div>
              <button
                onClick={onGetCertificateClick}
                className="flex-1 bg-blue-400 text-white py-3 font-semibold hover:bg-blue-600"
              >
                Get Course Certificate
              </button>
            </div>
          ) : (
            <button
              onClick={() => handleComingSoonClick("End June")}
              className="bg-gray-400 text-white py-3 px-4 w-full font-semibold cursor-not-allowed"
            // onClick={onButtonClick}
            // className="bg-blue-400 text-white py-3 px-4 w-full font-semibold cursor-not-allowed"
            >
              {buttonLabel || "Apply Course Code"}
            </button>
          )}
        </div>
        {isOpen && (
          <CreateCertificateDetailsModal
            setOpenModal={setOpen}
            planName={plan.invoice_plan_category}
            planId={planId}
            devProjId={project?.developer_proj_id}
            environment={InvoicePlanSyscodeString[currentTab.invoicePlanSyscode]}
          />
        )}
      </div>
    );
  }

  return null;
}